



























































import { PopRoute, AddRoute, ReplaceRoute } from '../../types/store';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {Getter, Mutation, State} from "vuex-class";
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import PackageCard from './PackageCard.vue';
import Axios from "axios";
import alzuhudLink, {makeArabic} from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        PackageCard
    }
})
export default class UserBookings extends Vue {
    private panelTitle: string;
    @State adminUser: string;
    @State routes: string[];
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @Getter token: string;
    @Mutation setBookingId: Function;
    @State language: any;
    tableLoading: boolean = true;
    pagesCount: number = 1;
    page: number = 1;
    search: string = '';

    headers: any[] = [];

    desserts: any[] = [];

    async mounted() {
        this.replaceRoute(['Bookings']);
        this.$parent.$emit('update route');
        this.headers = this.language === 'ar'?  [
            {
                text: 'الاسم',
                align: 'left',
                value: 'name',
            },
            { text: 'التاریخ', value: 'date' },
            { text: 'السعر', value: 'price' },
            { text: 'الرکاب', value: 'passengers' },
            { text: 'OP', value: 'action', sortable: false },
        ]:[
            {
                text: 'Name',
                align: 'left',
                value: 'name',
            },
            { text: 'Date', value: 'date' },
            { text: 'Price', value: 'price' },
            { text: 'Passengers', value: 'passengers' },
            { text: 'OP', value: 'action', sortable: false },
        ];
        try {
            const response = await Axios.get(`http://${alzuhudLink}:8080/api/booking/all`, {
                params: {
                    token: this.token,
                }
            });

            this.pagesCount = response.data.res.last_page;
            this.desserts = response.data.res.data.map((item: any) => ({
              id: item.id,
              name: item.name,
              passengers: (item.num_childs + item.num_adults),
              price: item.total_price,
              date: item.package_id.start_date || '...',
            }));

        } catch (e) {
        } finally {
            this.tableLoading = false;
        }
        // const package = response.data.
    }
    /**
     *
     */
    constructor() {
        super();
        this.panelTitle = 'Bookings';
    }
    beforeDestroy(): void {
        this.popRoute();
        this.$parent.$emit('update route');
    }

    makeArabic(str: string): string {
        return makeArabic(str);
    }

    checkTicket(id: any): void {
        this.setBookingId(id);
        this.$router.push('booking');
    }

    async changePage(e: any) {
        if (e !== undefined) {
            this.tableLoading = true;
            this.desserts = [];
            try {
                const response = await Axios.get(`http://${alzuhudLink}:8080/api/booking/all`, {
                    params: {
                        token: this.token,
                        page: e,
                    }
                });

                this.desserts = response.data.res.data.map((item: any) => ({
                    id: item.id,
                    name: item.name,
                    passengers: (item.num_childs + item.num_adults),
                    price: item.total_price,
                    date: item.package_id.start_date || '...',
                }));

            } catch (e) {
            } finally {
                this.tableLoading = false;
            }
        }
    }

    async searchBooking() {
        this.tableLoading = true;
        this.desserts = [];
        try {
            const response = await Axios.get(`http://${alzuhudLink}:8080/api/booking/all`, {
                params: {
                    token: this.token,
                    search: this.search,
                }
            });

            this.desserts = response.data.res.data.map((item: any) => ({
                id: item.id,
                name: item.name,
                passengers: (item.num_childs + item.num_adults),
                price: item.total_price,
                date: item.package_id.start_date || '...',
            }));

        } catch (e) {
        } finally {
            this.tableLoading = false;
        }
    }
}
